import {
  KubernetesAiSavingsOpportunity,
  SavingsOpportunity,
} from "@/services/cloudchipr.api";

export const isKubernetesAiSavingsOpportunity = (
  opportunity: SavingsOpportunity | KubernetesAiSavingsOpportunity,
): opportunity is KubernetesAiSavingsOpportunity => {
  return "cluster" in opportunity;
};
